<template>
    <div class="dashboard">
        <a-row :gutter="24" type="flex" align="stretch">
            <a-col :span="24" :lg="12">

                <h2 class="p-15">General Statistics</h2>
                <a-row :gutter="24">
                    <a-col :span="12" :lg="24" :xl="12" class="mb-24 text-right" style="position: relative; z-index: 1;">
                    <!-- Total Sales By App-->
                        <widget-counter
                            title="Sales By App"
                            :value="salesByApp"
                            :suffix="orderedByApp"
                            icon="appstore"
                            prefix="NOK"

                        />
                    <!-- / Total Sales By App -->
                    </a-col>
                    <a-col :span="12" :lg="24" :xl="12" class="mb-24 text-right" style="position: relative; z-index: 1;">
                     <!-- Total Sales By Phone -->
                        <widget-counter
                            title="Sales By Phone"
                            :value="salesByPhone"
                            :suffix="orderedByPhone"
                            icon="phone"
                            prefix="NOK"
                        />
                         <!-- / Total Sales By Phone -->
                    </a-col>
                </a-row>

                <!-- Sales By Products Table -->
				<a-row :gutter="24">
					<a-col :span="24" :lg="24" class="mb-24" style="position: relative; z-index: 1;">
						<sales-by-product-card :dataTable="salesByProduct"
                        />
					</a-col>
				</a-row>
				<!-- / Sales By Products Table -->
            </a-col>
        </a-row>

        <a-row :gutter="24" type="flex" align="stretch">
            <a-col :span="24" :lg="12">

                
               
            </a-col>
        </a-row>
        <br/>
       
        <a-row :gutter="24" type="flex" align="stretch">
           
            <a-col :span="24" :lg="24">
                
            </a-col>
            
        </a-row>
        
        <!-- Container -->

        <loading-modal ref="loadingModalRef"/>
        
    </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

import LoadingModal from '../../components/modals/LoadingModal.vue'
import WidgetCounter from '../../components/cards/WidgetCounter.vue'
import SalesByProductCard from '../../components/cards/SalesByProductCard.vue'
export default {

    inject: ['eventBus'],

    components : {
        LoadingModal,
        WidgetCounter,
        SalesByProductCard
    },
    
    computed : {
        ...mapState({
            
        }),
        ...mapGetters({
            
            totalOrders : 'orderManager/totalOrders',
            salesByApp : 'orderManager/salesByApp',
            salesByPhone : 'orderManager/salesByPhone',
            orderedByApp : 'orderManager/orderedByWebApp',
            orderedByPhone : 'orderManager/orderedByPhone',
            salesByProduct : 'orderManager/salesByProduct',

        })
    },

    data () {
        return {
           

        }
    },

    methods : {
        
        

      
       

       

        async sleep(miliSeconds) {
            return new Promise(r => setTimeout(r, miliSeconds));
        },

        



    },
    
    created() {
        //this.$message.loading('Loading data...', 0);
        //await this.$store.dispatch('orderManager/getCurrentOrdersAction', {});
    },
    destroyed() {
        //this.$barcodeScanner.destroy();

    }
}
</script>

<style scoped>

</style>